import script from "./WhitepaperPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WhitepaperPage.vue?vue&type=script&setup=true&lang=js"

import "./WhitepaperPage.vue?vue&type=style&index=0&id=110edd32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110edd32"]])

export default __exports__